export default __webpack_public_path__ + "static/ameridisability-9c9949ae211321755c469193898e5bad.svg";